const compareToFirstPassword = (form, rule, value, callback) => {
    if (value && value !== form.getFieldValue("password")) {
      callback("Your password is inconsistent. Please check");
    } else {
      callback();
    }
  };

  export default compareToFirstPassword